import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import QuestionWithRetrieval from "../QuestionWithRetrieval";
import Question from "../../containers/Question";

import { getUserInfo, setApisURLS } from "../../submodule/src/utils/api";

import Lottie from "lottie-react";
import animationData from "../../assets/cogsol-loading.json";

const MainRouter = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const initializeApp = async () => {
      if (!process.env.REACT_APP_IS_LOCAL_ENV) {
        await getUserInfo();
        const storedValue = sessionStorage.getItem("userRole");
        const role = storedValue ? JSON.parse(storedValue) : "";
        setApisURLS(role);
      }
      setTimeout(() => {
        setIsLoading(false);
      }, 300);
    };

    (async () => {
      await initializeApp();
    })();
  }, []);

  if (isLoading)
    return (
      <div className="flex justify-center items-center h-screen">
        <div>
          <Lottie
            animationData={animationData}
            style={{
              height: "260px",
              width: "260px",
              margin: "auto",
              marginTop: "0px",
            }}
          />
        </div>
      </div>
    );

  return (
    <BrowserRouter>
      <Routes>
        <Route
          index
          element={
            <QuestionWithRetrieval defaultRetrievalId={process.env.REACT_APP_RETRIEVAL} />
          }
        />
        <Route path="projects/:idRetrieval/chats/:id" element={<Question />} />
      </Routes>
    </BrowserRouter>
  );
};

export default MainRouter;
